module.exports = __webpack_public_path__ + "img/right-background.345f6016.png";